import AppBar from 'material-ui/AppBar';
import Paper from 'material-ui/Paper';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styles from '../../constants/styles';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import { withStyles } from 'material-ui/styles';

export class FormFrame extends Component {
  render() {
    const { classes, label, description, children } = this.props;

    return (
      <Paper className={classes.paper}>
        <AppBar position="static" color="default">
          <Toolbar>
            <Typography
              variant="title"
              color="inherit"
              align="center"
              data-test="label"
             >
              { label }
            </Typography>
          </Toolbar>
        </AppBar>
        <Paper className={classes.paper} elevation={4}>
          <Typography
            component="p"
            align="left"
            data-test="description"
            variant="subheading"
            className={classes.secondaryText}
           >
            { description }
          </Typography>
          { children }
        </Paper>
      </Paper>
    );
  }
}

FormFrame.propTypes = {
  classes:     PropTypes.object.isRequired,
  label:       PropTypes.string.isRequired,
  description: PropTypes.string,
  children:    PropTypes.element.isRequired,
}

export default withStyles(styles)(FormFrame);



// WEBPACK FOOTER //
// ./src/components/common/FormFrame.js